import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Spinner from '@ow/ow-components/lib/components/Spinner';
import { identityConnector } from '@ow/identity-components/lib/store/connectors';
import { isEmptyObj } from 'connected-components/utils/commonUtils';
import { ExternalLinksDictionary } from 'connected-components/dictionaries/external-links';
import { getSearchParams } from 'connected-components/utils/urlUtils';

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
`;

class IdentityLoginComponent extends Component {
  componentDidMount() {
    this.handleRedirection();
  }

  componentDidUpdate() {
    this.handleRedirection();
  }

  handleRedirection() {
    const { profile, login, isLoggedIn } = this.props;
    if (!isEmptyObj(profile)) {
      const pageURLToReload = getSearchParams().get('pageURLToReload');
      const redirectPath = pageURLToReload || ExternalLinksDictionary.user.myaccount;
      isLoggedIn ? window.location.assign(redirectPath) : login({ redirectPath });
    }
  }

  render() {
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    );
  }
}

IdentityLoginComponent.propTypes = {
  profile: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  login: PropTypes.func
};

IdentityLoginComponent.defaultProps = {
  profile: {},
  isLoggedIn: false,
  login: () => {}
};

export { IdentityLoginComponent };
export default identityConnector(IdentityLoginComponent);
